import { Snowflake } from 'lucide-react';
import { Label } from '@/components/atoms/texts/label';
import { InterestsHoldPeriod } from '@/components/molecules/InterestsHoldIcon';
import PrintInformationMessage from '@/components/organisms/feedback/PrintInformationMessage';

export default function InterestsHoldUpcomingInformation({ hold, className }) {
    if (!hold) return null;

    return (
        <PrintInformationMessage
            className={className}
            isComponent
            information={
                <div className="flex flex-wrap items-center gap-firstDegree">
                    <Snowflake className="h-4 w-4 text-informative-foreground" />
                    <Label fontWeight="semibold" message="consultants.statement.interestsHolds.upcomingHoldInformation" />
                    <InterestsHoldPeriod hold={hold} />
                    {hold.comment && <Label size="small" color="disabled">{hold.comment}</Label>}
                </div>
            }
        />
    );
}
